module.exports = __webpack_public_path__ + "static/media/objects2_20.fc2f17ec.svg";